import { TO_ORDER, TO_PROMISE } from "./product/displayProductAvailability";

export const displayWarehouseAllocationToOrder = (toOrder: boolean): string =>
  toOrder ? TO_ORDER : TO_PROMISE;
